import jwt_decode from 'jwt-decode';


export default function getUrlAndPubKeyFromToken(token) {
  const tokenPayload = jwt_decode(token);
  return {
    pubKey: tokenPayload.pubKey,
    url:    tokenPayload.vsu,
  };
}